/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filtericon': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M1.98 1.9h7.684L6.747 5.93a.5.5 0 0 0-.095.293v2.66a.5.5 0 1 0 1 0V6.384l3.396-4.69A.5.5 0 0 0 10.643.9H1a.5.5 0 0 0-.405.793l3.396 4.691V10.6a.5.5 0 0 0 1 0V6.222a.5.5 0 0 0-.095-.293L1.98 1.9z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
